import { render, staticRenderFns } from "./GroupBadges.vue?vue&type=template&id=e050bb74&scoped=true&"
import script from "./GroupBadges.vue?vue&type=script&lang=js&"
export * from "./GroupBadges.vue?vue&type=script&lang=js&"
import style0 from "./GroupBadges.vue?vue&type=style&index=0&id=e050bb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e050bb74",
  null
  
)

export default component.exports